<template>
  <svg
    viewBox="0 0 477 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_11_163)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M156.8 90.2L166.1 105.6L156.8 120H336.4L328.4 105.6L336.4 90.2H156.8Z"
        fill="#4F2B1B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.2 18.4L27.2 43.6L20.8 18.4H0V29.1H3.7V68.2H0V78.8H17.8V68.2H14.7V30.7L23.7 66.6H28.8L38.9 30.8L38 68.2H35V78.8H54.3V68.2H50.6V29.1H54.3V18.4H34.2Z"
        fill="#4F2B1B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.7 78.8V68.2H62.5V29.1H58.7V18.4H80.5999V29.1H76.8V68.2H80.5999V78.8H58.7Z"
        fill="#4F2B1B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M84.1 78.8V68.2H86.7L98.5 49.5L86.6 29.1H84.4V18.4H103.7V29.1H100.4L105.6 38.1L111.3 29.1H108V18.4H125.3V29.1H123.4L111.7 47.7L123.2 68.2H125.3V78.8H106V68.2H109.1L104.3 59.2L98.7 68.3H101.4V78.9H84.1V78.8Z"
        fill="#4F2B1B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M127.9 78.8V68.2H131.7V29.1H127.9V18.4H149.8V29.1H146V68.2H149.8V78.8H127.9Z"
        fill="#4F2B1B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M163.2 78.8V68.2H166.9V28.3H162.3V37.6H154.2V18.4H193.6V37.6H185.5V28.3H180.9V68.2H184.5V78.8H163.2Z"
        fill="#4F2B1B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M298.914 78.6V68.1H302.614V29.1H298.914V18.4H319.814V29.1H316.714V46.9L328.314 29.1H324.314V18.4H343.814V29.1H340.514L328.914 46.9L340.814 68.2H343.914V78.8H324.114V68.1H327.514L316.814 47.2V68.1H319.914V78.7L298.914 78.6Z"
        fill="#4F2B1B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M346.114 78.5V67.9H349.814V29.1H346.114V18.4H367.614V29.1H363.914V68.3H373.914V57.9H384.914V78.5H346.114Z"
        fill="#4F2B1B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M390.814 63.3V29.1H387.114V18.4H408.014V29.1H404.914V62.5C404.914 66.2 406.514 68.1 409.814 68.1C413.114 68.1 414.714 66.2 414.714 62.5V29.1H411.614V18.4H432.414V29.1H428.814V63.3C428.814 74.2 422.514 79.7 409.814 79.7C403.614 79.7 398.814 78.3 395.614 75.5C392.414 72.7 390.814 68.6 390.814 63.3Z"
        fill="#4F2B1B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M453.914 68.7H456.514C458.714 68.7 460.314 68.2 461.214 67.2C462.114 66.2 462.614 64.5 462.614 62.1V57.4C462.614 55.4 462.114 53.9 461.114 53C460.114 52.1 458.514 51.6 456.214 51.6H453.914V68.7ZM453.914 42H456.314C458.514 42 460.114 41.7 461.014 41C461.914 40.3 462.314 38.9 462.314 36.9V33.6C462.314 31.7 461.914 30.4 461.014 29.5C460.114 28.7 458.614 28.3 456.514 28.3H453.914V42ZM436.914 78.5V67.9H440.614V29.1H436.914V18.4H458.214C464.014 18.4 468.214 19.5 470.914 21.7C473.614 23.9 475.014 27.4 475.014 32.2V33.8C475.014 37.8 474.114 40.8 472.414 42.9C470.614 45 467.814 46.3 463.914 46.8C468.114 47.3 471.214 48.6 473.214 50.7C475.114 52.8 476.114 55.8 476.114 59.9V62.6C476.114 68.3 474.814 72.4 472.314 74.8C469.814 77.3 465.614 78.5 459.714 78.5H436.914Z"
        fill="#4F2B1B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M268.414 0.100006C257.614 0.100006 248.514 7.50001 246.014 17.5C243.514 7.50001 234.414 0.100006 223.614 0.100006C210.814 0.100006 200.514 10.4 200.514 23.2C200.514 29.1 203.214 34.9 206.414 39.3C217.214 54.2 245.914 87.7 245.914 87.7C245.914 87.7 276.414 53 285.414 39.3C287.814 35.7 291.314 29.1 291.314 23.2C291.514 10.4 281.214 0.100006 268.414 0.100006Z"
        fill="#4F2B1B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M278.214 27.6L273.814 24.1C273.814 24.1 275.314 13.4 266.214 12.2C253.714 10.6 257.314 28.6 253.814 31.3C246.514 23.9 233.114 18.1 233.114 18.1C233.114 18.1 235.914 37.3 241.314 44.1C241.714 44.6 242.214 45.1 242.614 45.5C241.214 45 239.914 44 238.814 42.6C237.114 40.4 235.614 36.9 234.414 33.3C225.414 31.5 219.614 27.7 219.614 27.7C219.614 27.7 219.714 27.8 219.814 28L219.514 27.8C219.614 43.7 229.514 56.9 243.014 58.4C257.914 60.1 271.514 47 273.614 29.2L278.214 27.6Z"
        fill="#F9A52D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M269.114 22.7C268.714 24 267.314 24.8 266.014 24.4C264.714 24 263.914 22.7 264.314 21.3C264.714 20 266.114 19.2 267.414 19.6C268.714 20 269.514 21.4 269.114 22.7Z"
        fill="#FEFEFE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M268.014 22.4C267.814 23.1 267.114 23.5 266.314 23.3C265.614 23.1 265.214 22.3 265.414 21.6C265.614 20.9 266.414 20.5 267.114 20.7C267.814 20.9 268.214 21.7 268.014 22.4Z"
        fill="#73331C"
      />
      <path
        d="M175.814 110.7H177.314V99.6H175.814V98.3H180.714C182.214 98.3 183.314 98.5 184.014 99C184.714 99.5 185.014 100.3 185.014 101.5V102.8C185.014 104 184.714 104.8 184.114 105.3C183.514 105.8 182.614 106.1 181.314 106.1H179.014V110.7H180.414V111.9H175.714V110.7H175.814ZM180.514 104.8C181.514 104.8 182.214 104.7 182.614 104.4C183.014 104.1 183.214 103.6 183.214 102.8V101.5C183.214 100.8 183.014 100.3 182.614 100.1C182.214 99.9 181.614 99.7 180.614 99.7H179.114V104.9H180.514V104.8Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M186.214 110.7H187.714V99.6H186.214V98.3H191.214C192.714 98.3 193.814 98.5 194.414 99C195.014 99.5 195.314 100.2 195.314 101.4V102.3C195.314 103.1 195.114 103.7 194.814 104.1C194.514 104.5 193.814 104.7 192.914 104.9C193.814 105 194.414 105.2 194.814 105.4C195.214 105.6 195.314 106.2 195.314 106.9V110.7H196.714V111.9H193.514V106.9C193.514 106.3 193.414 105.9 193.114 105.7C192.814 105.5 192.314 105.4 191.514 105.4H189.514V110.6H190.914V111.8H186.214V110.7ZM191.414 104.1C192.814 104.1 193.514 103.5 193.514 102.4V101.1C193.514 100.5 193.314 100.1 193.014 99.9C192.714 99.7 192.114 99.6 191.314 99.6H189.514V104.1H191.414Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M197.414 110.7H198.914V99.6H197.414V98.3H206.614V101.9H205.014V99.6H200.714V103.9H204.314V105.3H200.714V110.6H205.114V107.9H206.714V111.9H197.414V110.7Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M211.814 98.3C213.914 98.3 215.414 98.7 216.314 99.4C217.214 100.1 217.614 101.5 217.614 103.4V106.6C217.614 108.5 217.214 109.8 216.414 110.7C215.614 111.5 214.214 112 212.414 112H208.114V110.8H209.614V99.6H208.114V98.3H211.814ZM211.314 110.6H211.814C213.214 110.6 214.214 110.3 214.714 109.7C215.214 109.1 215.614 108.1 215.614 106.8V103.2C215.614 101.9 215.314 101 214.814 100.4C214.314 99.9 213.314 99.6 211.914 99.6H211.314V110.6Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M218.814 110.7H220.314V99.6H218.814V98.3H223.714C225.214 98.3 226.314 98.5 227.014 99C227.714 99.5 228.014 100.3 228.014 101.5V102.8C228.014 104 227.714 104.8 227.114 105.3C226.514 105.8 225.614 106.1 224.314 106.1H222.014V110.7H223.414V111.9H218.714V110.7H218.814ZM223.514 104.8C224.514 104.8 225.214 104.7 225.614 104.4C226.014 104.1 226.214 103.6 226.214 102.8V101.5C226.214 100.8 226.014 100.3 225.614 100.1C225.214 99.9 224.614 99.7 223.614 99.7H222.114V104.9H223.514V104.8Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M229.214 110.7H230.714V99.6H229.214V98.3H233.914V99.6H232.514V110.6H236.914V107.9H238.514V111.9H229.214V110.7Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M239.514 110.7H240.614L243.814 99.6H242.414V98.3H247.914V99.6H246.514L249.714 110.7H250.714V111.9H246.414V110.7H247.914L247.114 107.7H243.114L242.214 110.7H243.714V111.9H239.514V110.7ZM246.714 106.4L245.114 100.2L243.414 106.4H246.714Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M252.014 110.7H253.914V99.6H251.914V102H250.314V98.3H259.414V102H257.814V99.6H255.814V110.7H257.714V111.9H252.014V110.7Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M260.514 110.7H262.014V99.6H260.514V98.3H265.214V99.6H263.814V110.7H265.214V111.9H260.514V110.7Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M268.114 110.7H270.014V99.6H268.014V102H266.314V98.3H275.414V102H273.814V99.6H271.814V110.7H273.714V111.9H268.014V110.7H268.114Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M276.614 110.7H278.114V99.6H276.614V98.3H285.814V101.9H284.214V99.6H279.914V103.9H283.514V105.3H279.914V110.6H284.314V107.9H285.914V111.9H276.614V110.7Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M287.314 110.7H288.814V99.6H287.314V98.3H292.014V99.6H290.614V110.6H295.014V107.9H296.614V111.9H287.314V110.7ZM294.614 98.3L293.514 101.7H292.314L293.414 98.3H294.614Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M305.914 108.1C305.914 110.8 304.514 112.2 301.814 112.2C299.114 112.2 297.714 110.8 297.714 108.1V102.1C297.714 99.4 299.114 98 301.814 98C304.514 98 305.914 99.4 305.914 102.1V108.1ZM301.814 99.4C300.314 99.4 299.614 100.3 299.614 102.1V108.1C299.614 109 299.814 109.7 300.114 110.1C300.514 110.5 301.014 110.7 301.814 110.7C303.314 110.7 304.014 109.8 304.014 108V102C304.014 100.3 303.314 99.4 301.814 99.4Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
      <path
        d="M307.814 99.6H306.914V98.3H311.014V99.6H309.714L311.914 108.8L314.114 99.6H312.814V98.3H316.814V99.6H315.714L312.514 112.1H311.114L307.814 99.6Z"
        fill="white"
        stroke="white"
        stroke-width="0.25"
        stroke-miterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_163">
        <rect
          width="477"
          height="120"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
